export default __webpack_public_path__ + "assets/front/scss/editorial.7822db05e44546d489a23b657be6e51d.css";